"use client";

import React from "react";
import { motion } from "framer-motion";

export default function SectionDivider() {
  return (
    <motion.div
      className="my-2 h-px w-16 rounded-full bg-[var(--color-border)] hidden sm:block"
      initial={{ opacity: 0, scaleX: 0 }}
      animate={{ opacity: 1, scaleX: 1 }}
      transition={{ delay: 0.3, duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
    />
  );
}
